import type { JSX } from 'react'

export const PauseSolidIcon = (): JSX.Element => (
  <use href='#pauseSolidIcon' height='100%' width='100%' />
)
